import { api } from '@/portal-api.definition';
import { queryOptions } from '@tanstack/react-query';
import { useNosIdQuery } from './base.hooks';

export const profilesQueryOptions = (sa: string) =>
  queryOptions({
    queryKey: ['profiles', sa],
    queryFn: () => api.get('/api/v1/profiles/:sa', { params: { sa } }),
  });

export function useGetProfiles(sa: string, enabled?: boolean) {
  return useNosIdQuery({ ...profilesQueryOptions(sa), enabled });
}
